




import { Component, Vue, Watch } from 'vue-property-decorator'
import * as qs from 'qs'
import { isWeixin, cacheGet } from '@ivy/fts/utils'
import { sleep } from '@ivy/fts/utils'
import { isZfb } from './util'
import { requireGet, requirePost } from './require'

@Component
export default class VerifyPayResult extends Vue {
  tid: any
  async created() {
    let { tid, url, cancelUrl } = this.$route.query
    if (isZfb()) {
      tid = this.$route.query.out_trade_no
      url = cacheGet('redirect')
      cancelUrl = cacheGet('cancelUrl')
    }

    // 这里只针对非微信H5支付
    await this.$MessageBox({
      message: '确认支付是否已完成',
      title: '提示',
    })
    // 无论用户是否点击确认都要对支付结果校验
    this.$Indicator.open({
      text: '加载中',
      spinnerType: 'snake',
    })
    const { data: payResult } = await requireGet(
      `/api/goods/order/pay/getPayResult?tid=${tid}`
    )
    this.$Indicator.close()
    if (payResult.state === 'paid') {
      // 支付成功
      this.$Toast('支付成功')
      window.location.replace(`${url}`)
    } else {
      await this.$Toast('支付失败请稍后重试')
      await sleep(50)
      window.location.replace(decodeURIComponent(cancelUrl.toString()))
    }
  }
}
